export const REASON = [
    {
        value: '',
        name: 'Tất cả'
    },
    {
        value: 'label_error',
        name: 'Label hỏng'
    },
    {
        value: 'new_setting',
        name: 'Gen theo setting mới'
    },
    {
        value: 'other',
        name: 'Lý do khác'
    },
    {
        value: 'change_shipping_carrier',
        name: 'Thay đổi shipping carrier'
    }
]

export const STATUS = [
    {
        value: '',
        name: 'Tất cả'
    },
    {
        value: 'upload.error',
        name: 'Không upload thành công'
    },
    {
        value: 'approved.pending',
        name: 'Chờ duyệt'
    },
    {
        value: 'approved.approved',
        name: 'Đã duyệt'
    },
    {
        value: 'approved.rejected',
        name: 'Từ chối duyệt'
    },
    {
        value: 'generate.failed',
        name: 'Gen label không thành công'
    },
    {
        value: 'generate.done',
        name: 'Đã gen lại label'
    },
    {
        value: 'generate.updated_setting',
        name: 'Đã thay đổi setting mới'
    },
]

export const LIMIT = [
    {name: '20 rows', value: 20},
    {name: '50 rows', value: 50},
    {name: '100 rows', value: 100},
    {name: '200 rows', value: 200},
]

export const LIST_SHIPPING_CARRIER = [
    {value: '', name: 'Default'},
    {value: 'multrans_us', name: 'Multrans US'},
    {value: 'multrans_eu', name: 'Multrans EU'},
    {value: 'shippo_us', name: 'Shippo US'},
    {value: 'ib_blue', name: 'IB Blue'},
    {value: 'royal_mail', name: 'Royal Mail'},
    {value: 'flashship_usps', name: 'LLC USPS'},
    {value: 'hw_usps', name: 'HW_USPS'},
    {value: 'hw_ups', name: 'HW_UPS'},
    {value: 'hw_gb', name: 'HW_GB'},
    {value: 'hw_tiktok', name: 'HW_TIKTOK'},
    {value: 'zone9_us', name: 'ZONE9_US'},
    {value: 'zone9_ca', name: 'ZONE9_CA'},
    {value: 'LB_USPS', name: 'LB_USPS'},
    {value: 'jt_usps', name: 'JT_USPS'},
    {value: 'ns_usps', name: 'NS_USPS'},
    {value: 'hw_tiktok', name: 'HW TIKTOK'},
    {value: 'hw_ttship', name: 'HW TTSHIP'},
    {value: 'hw_gb_ttship', name: 'HW GB TTSHIP'},
    {value: 'ge_dhl', name: 'ITC Standard'},
    {value: 'ge_tiktok', name: 'ITC TIKTOK'},
    {value: 'hw_tiktok_gb', name: 'GB HW TIKTOK'},
    {value: 'ge_ttship', name: 'ITC TTSHIP'},
    {value: 'itc_spx', name: 'ITC SPX'},
    {value: 'itc_gofo', name: 'ITC GOFO'},
    {value: 'kl_dhl', name: 'KL Standard'},
    {value: 'kl_ttship', name: 'KL TTSHIP'},
    {value: 'kl_usps', name: 'KL USPS'},
]